// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"66d6107c","348":"2aa1d8fa","552":"65fd8607","706":"a920d7fa","978":"924077ce"}[chunkId] + ".chunk.css";
};